module.exports = __webpack_public_path__ + "45dbd7310957c4478428486b848b7172.png";